import React, { useEffect, useState } from 'react'
import { Box } from '@mui/material'
import Rte, { EditorValue, ToolbarConfig } from 'react-rte'
import { advancedColors } from '../../theme'

const toolbarConfig: ToolbarConfig = {
  display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS'],
  INLINE_STYLE_BUTTONS: [
    { label: 'Bold', style: 'BOLD' },
    { label: 'Italic', style: 'ITALIC' },
    { label: 'Underline', style: 'UNDERLINE' },
  ],
  BLOCK_TYPE_BUTTONS: [
    { label: 'UL', style: 'unordered-list-item' },
    { label: 'OL', style: 'ordered-list-item' },
  ],
  BLOCK_TYPE_DROPDOWN: [],
  BLOCK_ALIGNMENT_BUTTONS: [],
}

const hiddenToolbar: ToolbarConfig = {
  ...toolbarConfig,
  display: [],
}

const fromHtml = (html: string): EditorValue =>
  html ? Rte.createValueFromString(html, 'html') : Rte.createEmptyValue()

type Props = {
  value: string
  onChange: (html: string) => void
  minHeight?: number
  editable?: boolean
}

const RichTextEditor = ({ value, onChange, minHeight = 200, editable = true }: Props) => {
  const [editorValue, setEditorValue] = useState(() => fromHtml(value))

  // Skip re-applying value from this editor's own onChange (ADR-047).
  useEffect(() => {
    setEditorValue((current) => (value === current.toString('html') ? current : fromHtml(value)))
  }, [value])

  const handleChange = (next: EditorValue) => {
    setEditorValue(next)
    onChange(next.toString('html'))
  }

  return (
    <Box
      sx={{
        border: `1px solid ${advancedColors.line}`,
        borderRadius: 1,
        backgroundColor: advancedColors.surface,
        overflow: 'hidden',
        '& .public-DraftEditor-content': {
          minHeight,
          color: advancedColors.ink,
        },
      }}
    >
      <Rte
        value={editorValue}
        onChange={handleChange}
        readOnly={!editable}
        toolbarConfig={editable ? toolbarConfig : hiddenToolbar}
        placeholder={editable ? 'Start typing…' : undefined}
        editorStyle={{ padding: 12 }}
      />
    </Box>
  )
}

export default RichTextEditor
